const ACCESS_STATUS = Object.freeze({
	NO_ACCESS: 'rejected',
	PENDING: 'pending',
	APPROVED: 'approved'
});

export default ACCESS_STATUS;
